<form [formGroup]="form">
    <div class="row">
        @for (field of customFields(); track $index) {
            <div class="col-12 col-md-6 pb-2" [class.mt-2]="field.type === fieldTypes.TITLE" [class.col-md-6]="field.type !== fieldTypes.TITLE">
                @if (field.type !== fieldTypes.TITLE) {
                    <label>{{field.name}} 
                        @if (field.required) {
                            <span class="required_asterisk"> *</span>
                        }
                    </label>
                }
                <app-custom-field-input
                    [customField]="field"
                    [type]="field?.type"
                    formControlName="{{field.id.toString()}}"
                />               
                <small [innerHTML]="field.description" class="mt-1"></small>
                <!-- 
                <div *ngIf="form.get(field.id.toString())?.hasError('required') && submitAttempted">
                    <p class="mt-0 mb-3 text-danger">{{ 'RequiredField' | translate }}</p>
                </div> -->
            </div>
        }
    </div>
</form>